$('.round').click(function(){
	$('.friends_plan').toggleClass('hidden');
  	$('.pricing-payment').toggleClass('hidden');
  	$('.info').toggleClass('hidden');
  	$('.pricing-images').toggleClass('hidden');
  	$('.dot-container').toggleClass('hidden');
	$('.pricing-video-sec').toggleClass('hidden');  	


  	$('.teacher_plan').toggleClass('seen');
  	$('.info-teacher').toggleClass('shown');
	$('.whole-class').toggleClass('shown');
  	$('.pricing-images-teacher').toggleClass('shown');
	$('.free_trial_header').toggleClass('get_always-free');
	$('.pricing-free .button').toggleClass('change_content');

  if($('.free_trial_header').hasClass('get_always-free')){
		$('.free_trial_header').text('Always Free');		
  }else{
		$('.free_trial_header').text('Free 7 Day Trial');
}
  	if($('.pricing-free .button').hasClass('change_content')){
    	$('.change_content').text('Get Started'); 
		$(".trial-link").attr("href", "https://join.vooks.com/free-teacher/");
		$(".pricing-start-text-bottom").html("Get started with your free Vooks membership and make<br> storytime even more special.");
		
    }else {
    	$('.pricing-free .button').text('Start Free Trial');
		$(".trial-link").attr("href", "https://join.vooks.com/");
		$(".pricing-start-text-bottom").html("Try Vooks for free for 7 days and make<br> storytime even more special.");
		
    }
});


$('.cc').click(function(){
  $( ".round" ).trigger( "click" );
});



$(".dot_left").click(function () { 
  var leftPos = $('.friends_plan').scrollLeft();
  $(".friends_plan").animate({scrollLeft: leftPos - 200}, 300);
  $(".dot_left").addClass('active');
  $(".dot_right").removeClass('active');
});


$(".dot_right").click(function () { 
  var leftPos = $('.friends_plan').scrollLeft();
  $(".friends_plan").animate({scrollLeft: leftPos + 200}, 300);
  $(".dot_right").addClass('active');
  $(".dot_left").removeClass('active');
});


  const accordions = document.getElementsByClassName('weekly--accordion')
  const panels = document.getElementsByClassName('weekly--panel')

  for (let i = 0; i < accordions.length; i++) {
    accordions[i].addEventListener('click', function() {
      this.classList.toggle("active")

      const panel = panels[i]

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px'
      }
    })
  }